import { render, staticRenderFns } from "./potentialContaminants.vue?vue&type=template&id=031200aa&"
import script from "./potentialContaminants.ts?vue&type=script&lang=ts&"
export * from "./potentialContaminants.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports